import { Link, useLocation } from 'react-router-dom';
import { useArcheAdmin } from '@/auth';
import { cn } from '@/lib/utils';

const ARCHE_BASE = '/a/arche_liquidity_caches';

export function LcNav() {
  const { pathname } = useLocation();
  // Server route gate: `requireAdminOrLitcraftAdmin` (docs/api-admin.md).
  const isAdmin = useArcheAdmin('litcraft_admin');

  const links = [
    { to: ARCHE_BASE, label: 'Exchange Caches', exact: true },
    { to: `${ARCHE_BASE}/positions`, label: 'My Positions' },
    ...(isAdmin ? [{ to: `${ARCHE_BASE}/admin`, label: 'Admin' }] : []),
  ];

  return (
    <nav className="flex gap-1 border-b pb-2 mb-6">
      {links.map((link) => {
        const active = link.exact
          ? pathname === link.to || pathname === `${link.to}/`
          : pathname.startsWith(link.to);
        return (
          <Link
            key={link.to}
            to={link.to}
            className={cn(
              'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted',
            )}
          >
            {link.label}
          </Link>
        );
      })}
    </nav>
  );
}
